import { MasterInstance } from "@/instance/axios";
import { createQueryKeys } from "@lukemorales/query-key-factory";
import {
  MasterApiAuthorizationsAuthorizationIdDeleteRequest,
  MasterApiAuthorizationsAuthorizationIdPutRequest,
  MasterApiAuthorizationsFindPostRequest,
  MasterApiAuthorizationsGetRequest,
  MasterApiAuthorizationsPostRequest,
} from "@sizlcorp/sizl-api-document/dist/models";

export const authorizations = createQueryKeys("authorizations", {
  all: null,
  get: (params: MasterApiAuthorizationsGetRequest) => {
    const queryParams = {
      ...params,
      query: JSON.stringify({ $and: params?.query }),
      sort: params.sort?.length ? params.sort : "-id",
    }; // 권한 조회 시 기본 정렬 표시

    return {
      queryKey: [queryParams, JSON.stringify(queryParams)],
      queryFn: () => MasterInstance.authorizationsGet(queryParams),
    };
  },
  find: (params: MasterApiAuthorizationsFindPostRequest) => {
    const query = { ...params };
    if (Array.isArray(params.query?.$and) && params.query?.$and.length > 0) {
      query["query"] = JSON.stringify(params.query);
    }
    if (params.search) {
      query["search"] = params.search;
      query["searchFields"] = params.searchFields;
    }
    return {
      queryKey: [query, JSON.stringify(query.query)],
      queryFn: () => MasterInstance.authorizationsFindPost(query),
    };
  },
});

export const mutateAuthorization = {
  create: (params: MasterApiAuthorizationsPostRequest) => ({
    mutationKey: [params.authorizationsGetRequest],
    mutationFn: () => MasterInstance.authorizationsPost(params),
  }),
  update: (params: MasterApiAuthorizationsAuthorizationIdPutRequest) => ({
    mutationKey: [params.authorizationsGetRequest, params.authorizationId],
    mutationFn: () => MasterInstance.authorizationsAuthorizationIdPut(params),
  }),
  delete: (params: MasterApiAuthorizationsAuthorizationIdDeleteRequest) => ({
    mutationKey: [params.authorizationId],
    mutationFn: () => MasterInstance.authorizationsAuthorizationIdDelete(params),
  }),
};
